import {
  format as formatFn,
} from 'date-fns';
import nbLocale from 'date-fns/locale/nb';
import moment from 'moment';

const supressExceptions = (fn, ...params) => {
  try {
    return fn(...params);
  } catch {
    return null;
  }
};

const injectLocale = (options) => Object.assign(options || {}, { locale: nbLocale });

export const format = (date, format, options) => supressExceptions(formatFn, date, format, injectLocale(options));

// https://stackoverflow.com/a/44198641
export const isValidDate = (date) => date
  && Object.prototype.toString.call(date) === '[object Date]'
  && !Number.isNaN(date);

// formats from YYYY-MM-DD to DD.MM.YYYY
export const dateStrToNorwegianDateFormat = (dateStr) => {
  const parts = dateStr.split('-');

  return `${parts[2]}.${parts[1]}.${parts[0]}`;
};

// formats from YYYY-MM-DD HH:MM:SS.ffffff to DD.MM.YYYY HH:MM
export const dateStrWithHourMinutesToNorwegianDateFormat = (dateStr) => {
  const parts = dateStr.split(' ');
  const datePart = parts[0];
  const timePart = parts[1].replace(/\:[0-9]{2}\.[0-9]{6}/, '');

  return `${dateStrToNorwegianDateFormat(datePart)} ${timePart}`;
};

// https://stackoverflow.com/a/18478753
export const weeksInYear = (year) => Math.max(
  moment(new Date(year, 11, 31)).isoWeek(),
  moment(new Date(year, 11, 31 - 7)).isoWeek(),
);

export const incrementWeek = (startYear, startWeek) => {
  if (startWeek + 1 > weeksInYear(startYear)) {
    return [startYear + 1, 1];
  }
  return [startYear, startWeek + 1];
};

export const decrementWeek = (startYear, startWeek) => {
  if (startWeek - 1 === 0) {
    return [startYear - 1, weeksInYear(startYear - 1)];
  }
  return [startYear, startWeek - 1];
};

// given a year and a week, return what year and week will be in tree weeks
// return value [year:int, week:int]
export const getInTreeWeeks = (startYear, startWeek) => {
  const [year1, week1] = incrementWeek(startYear, startWeek);
  const [year2, week2] = incrementWeek(year1, week1);
  const [year3, week3] = incrementWeek(year2, week2);
  return [year3, week3];
};

export const getInFourWeeks = (startYear, startWeek) => {
  const [year3, week3] = getInTreeWeeks(startYear, startWeek);

  return incrementWeek(year3, week3);
};

export const momentByWeekAndYear = (week, year) => moment(`${year}`).add(week, 'weeks').isoWeekday(1);
